import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { selectAttendances, fetchAttendancesPage } from "../features/attendance/attendance.slice";
import { getDefaultAttendanceSearchCriteria } from "../service/model/attendance.model";

const useBusinesess = () => {
    const dispatch = useAppDispatch();
    const attendances = useAppSelector(selectAttendances);

    const getAttendancePage = async () => {
        await dispatch(fetchAttendancesPage(getDefaultAttendanceSearchCriteria()));
    }

    useEffect(() => {
        if (attendances.length === 0) {
            getAttendancePage();
        }
    }, []);

    return [attendances];
}
 
export default useBusinesess;